<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="550px" persistent>
    <v-card class="rounded-lg">
      <v-card-title class="text-h6 font-weight-bold  bg-deep-orange-darken-1">
        Запланировать учебное событие
      </v-card-title>

      <v-card-text class="px-4">
        <v-form ref="eventForm" v-model="isFormValid">

          <!-- Выбор типа события -->
          <v-select
            v-model="newEvent.eventType"
            :items="eventTypeOptions"
            item-title="title"
            item-value="value"
            label="Тип планируемого события"
            variant="outlined"
            density="comfortable"
            class="mb-2"
          ></v-select>

          <!-- Название -->
          <v-text-field
            v-model="newEvent.title"
            label="Тема / Название занятия"
            variant="outlined"
            density="comfortable"
            :rules="[v => !!v || 'Название обязательно к заполнению']"
            class="mb-2"
          ></v-text-field>

          <!-- Описание -->
          <v-textarea
            v-model="newEvent.description"
            label="Краткое описание / План лекции"
            variant="outlined"
            density="comfortable"
            rows="2"
            auto-grow
            class="mb-2"
          ></v-textarea>

          <!-- Выбор Команд / Групп -->
          <v-autocomplete
            v-model="newEvent.targetTeamIds"
            :items="availableTeams"
            item-title="personGroupName"
            item-value="id"
            label="Для каких команд / групп"
            variant="outlined"
            density="comfortable"
            multiple
            chips
            closable-chips
            :loading="isTeamsLoading"
            :rules="[v => (v && v.length > 0) || 'Выберите как минимум одну группу']"
            class="mb-2"
          ></v-autocomplete>

          <!-- Блок Даты и Времени -->
          <v-row class="mb-2" no-gutters>
            <v-col cols="12" sm="6" class="pr-sm-2 mb-2 mb-sm-0">
              <v-text-field
                v-model="newEvent.date"
                label="Дата события"
                type="date"
                variant="outlined"
                density="comfortable"
                :rules="[v => !!v || 'Дата обязательна']"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" class="pr-1">
              <v-text-field
                v-model="newEvent.startTime"
                label="Начало"
                type="time"
                variant="outlined"
                density="comfortable"
                :rules="[v => !!v || 'Время']"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" class="pl-1" v-if="newEvent.eventType !== 'TASK'">
              <v-text-field
                v-model="newEvent.endTime"
                label="Конец"
                type="time"
                variant="outlined"
                density="comfortable"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- ДИНАМИЧЕСКИЕ ПОЛЯ ДЛЯ ВЕБИНАРА -->
          <v-expand-transition>
            <div v-if="newEvent.eventType === 'WEBINAR'" class="bg-blue-lighten-5 pa-3 rounded-lg mb-3 border border-blue-lighten-3">
              <v-text-field
                v-model="newEvent.webinarLink"
                label="Ссылка на конференцию (Zoom/MTS)"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-link"
                :rules="[v => !!v || 'Введите ссылку на онлайн-комнату']"
                class="mb-2"
                hide-details="auto"
              ></v-text-field>
              <v-text-field
                v-model="newEvent.accessCode"
                label="Код доступа / Пароль"
                variant="outlined"
                density="comfortable"
                prepend-inner-icon="mdi-lock-outline"
                hide-details="auto"
              ></v-text-field>
            </div>
          </v-expand-transition>

          <!-- ТЕКСТОВОЕ ПОЛЕ МАТЕРИАЛОВ (Пока без привязки файлов) -->
          <v-textarea
            v-model="newEvent.selfStudyMaterials"
            label="Материалы для самостоятельного изучения / Текст лекции"
            variant="outlined"
            density="comfortable"
            rows="3"
            placeholder="Вставьте ссылки на литературу, инструкции или план подготовки..."
            prepend-inner-icon="mdi-book-open-page-variant-outline"
          ></v-textarea>

           <!-- НОВЫЙ БЛОК: Интерактивный загрузчик файлов методичек/PDF -->
                    <div class="mb-2">
                      <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                        <v-icon size="small" class="mr-1">mdi-paperclip</v-icon>
                        Прикрепить методические материалы (PDF, DOCX)
                      </div>
                      <!-- Наш дочерний компонент загрузчика -->
                      <FileUploader @files-updated="handleFilesUpdated" />
                    </div>

                <!-- БЛОК ПРИКРЕПЛЕНИЯ ВИДЕОМАТЕРИАЛОВ -->
                          <div class="mb-4">
                            <div class="text-caption font-weight-bold text-grey-darken-3 mb-1">
                              <v-icon size="small" class="mr-1">mdi-video-film</v-icon>
                              Видеоуроки и медиафайлы
                            </div>

                            <!-- Индикатор, если видео уже выбрано -->
                            <v-chip
                              v-if="newEvent.attachedVideoFile"
                              color="indigo-darken-3"
                              variant="flat"
                              closable
                              prepend-icon="mdi-play-circle"
                              class="font-weight-bold mb-2"
                              @click:close="newEvent.attachedVideoFile = null"
                            >
                              Привязано: {{ newEvent.attachedVideoFile.originalFileName }}
                            </v-chip>

                            <!-- Кнопка вызова нашей медиа-модалки -->
                            <v-btn
                              v-else
                              variant="outlined"
                              color="deep-orange-darken-1"
                              block
                              prepend-icon="mdi-folder-play-outline"
                              class="font-weight-bold"
                              @click="openMediaLibrary"
                            >
                              Выбрать или загрузить видеоролик
                            </v-btn>
                          </div>

                          <!-- НАШЕ ПОДКЛЮЧЕННОЕ ОКНО МЕДИАТЕКИ (Вызывается по кнопке выше) -->
                          <MediaViewerDialog
                            v-model="mediaDialog"
                            :active-module="activeMediaModule"
                            :video-files="mediaVideoFiles"
                            :download-animation="videoUploading"
                            :upload-percentage="videoUploadProgress"
                            :available-levels="videoAvailableLevels"
                            :current-level-index="videoCurrentLevel"
                            @init-player="handleInitHlsPlayer"
                            @change-quality="handleChangeVideoQuality"
                            @upload-video="handleVideoUpload"
                            @delete-file="handleVideoDelete"
                            @select-video-for-event="attachVideoToEvent"
                          />



        </v-form>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="grey-darken-1" variant="text" @click="closeDialog">Отмена</v-btn>
        <v-btn color="deep-orange-darken-1" variant="flat" class="px-4" :disabled="!isFormValid" :loading="isSaving" @click="saveEvent">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue' // <-- Добавьте импорты макросов
import { customAxios } from "@/service/customAxios";
import FileUploader from '@/schedule/FileUploader.vue'
import MediaViewerDialog from '@/schedule/MediaViewerDialog.vue' // Импорт медиатеки


// Состояния для медиа-диалога
const mediaDialog = ref(false)
const activeMediaModule = ref(null)
const mediaVideoFiles = ref([])
const videoUploading = ref(false)
const videoUploadProgress = ref(0)
const videoAvailableLevels = ref([])
const videoCurrentLevel = ref(-1)
let currentHlsInstance = null


// Открытие медиатеки в контексте текущего планируемого события
const openMediaLibrary = async () => {
  // Формируем объект модуля, чтобы медиатека поняла, куда грузить/что показывать
  activeMediaModule.value = {
    id: newEvent.value.id || 0, // Если событие новое, передаем 0 или ID, если редактируем
    courseModuleName: newEvent.value.title || 'Новое занятие'
  }

  // Загружаем список видео, если они уже есть
  mediaVideoFiles.value = []
  mediaDialog.value = true
}

// Перехват выбора видео: привязываем объект к нашему событию расписания
const attachVideoToEvent = (videoFile) => {
  newEvent.value.attachedVideoFile = videoFile
  mediaDialog.value = false // Закрываем медиатеку, возвращаемся в форму
}

// --- Ваши оригинальные функции для работы с Видео и HLS.js ---
const handleVideoUpload = async (event) => {
  const file = event.target.files?.[0]
  if (!file || !activeMediaModule.value) return
  try {
    videoUploading.value = true
    videoUploadProgress.value = 0
    let formData = new FormData()
    formData.append("file", file)

    const res = await customAxios.post("/video/upload/" + activeMediaModule.value.id, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          videoUploadProgress.value = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
        }
      }
    })
    if (res.status === 201) {
      // Видео успешно загружено на сервер, пушим его в список медиатеки
      mediaVideoFiles.value.push(res.data)
      // Автоматически привязываем к занятию
      attachVideoToEvent(res.data)
    }
  } catch (e) {
    console.error(e)
  } finally {
    videoUploading.value = false
  }
}

const handleInitHlsPlayer = (videoElement, streamUrl) => {
  if (!videoElement || !streamUrl) return
  let correctedStreamUrl = streamUrl
  if (!correctedStreamUrl.includes('/ts/')) {
    correctedStreamUrl = correctedStreamUrl.replace("index.m3u8", "ts/index.m3u8")
  }

  if (window.Hls && window.Hls.isSupported()) {
    if (currentHlsInstance) currentHlsInstance.destroy()
    const hls = new window.Hls({ maxMaxBufferLength: 10, enableWorker: true })
    currentHlsInstance = hls
    hls.loadSource(correctedStreamUrl)
    hls.attachMedia(videoElement)

    hls.on(window.Hls.Events.MANIFEST_PARSED, (event, data) => {
      videoAvailableLevels.value = data.levels.map((level, index) => ({
        index: index,
        name: level.height ? `${level.height}p` : `Разрешение ${index + 1}`
      })).reverse()
      videoCurrentLevel.value = hls.currentLevel
    })
  } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
    videoElement.src = correctedStreamUrl
    videoElement.load()
    videoAvailableLevels.value = [{ index: -1, name: 'Авто (Адаптивное)' }]
  }
}

const handleChangeVideoQuality = (levelIndex) => {
  videoCurrentLevel.value = levelIndex
  if (currentHlsInstance) {
    currentHlsInstance.currentLevel = levelIndex
    currentHlsInstance.nextLevel = levelIndex
    if (currentHlsInstance.streamController?.immediateLevelSwitch) {
      currentHlsInstance.streamController.immediateLevelSwitch()
    }
  }
}

const handleVideoDelete = async (fileId) => {
  if (!confirm('Удалить видео файл?')) return
  try {
    await customAxios.delete(`/video/${fileId}`)
    mediaVideoFiles.value = mediaVideoFiles.value.filter(f => f.id !== fileId)
  } catch (e) { console.error(e) }
}

// Определение входящих параметров (Props) и событий (Emits)
const props = defineProps({
  modelValue: { type: Boolean, required: true },
  defaultDate: { type: String, default: '' }
})
const emit = defineEmits(['update:modelValue', 'saved'])

// Состояния валидации и отправки данных
const isFormValid = ref(false)
const isSaving = ref(false)
const isTeamsLoading = ref(false)
const eventForm = ref(null)

// Справочники для формы
const availableTeams = ref([])
const eventTypeOptions = [
  { title: 'Занятие / Лекция', value: 'LESSON' },
  { title: 'Онлайн-вебинар (Zoom)', value: 'WEBINAR' },
  { title: 'Задание / Дедлайн', value: 'TASK' },
  { title: 'Самостоятельное обучение', value: 'SELF_STUDY' }
]

// Чистая структура новой записи
const defaultEvent = {
  title: '',
  description: '',
  eventType: 'LESSON',
  date: '',
  startTime: '',
  endTime: '',
  webinarLink: '',
  accessCode: '',
  selfStudyMaterials: '',
  targetTeamIds: [],
  attachedFileIds: []
}
// 3. Функция-обработчик, которую вызовет FileUploader при успешной загрузке
const handleFilesUpdated = (ids) => {
  newEvent.value.attachedFileIds = ids
}

const newEvent = ref({ ...defaultEvent })

// 📥 Загрузка списка команд с бэкенда для v-autocomplete
const fetchAvailableTeams = async () => {
  isTeamsLoading.value = true
  try {
    const response = await customAxios.get('/user_group')
    availableTeams.value = response.data
  } catch (e) {
    console.error('Ошибка загрузки списка команд для расписания:', e)
  } finally {
    isTeamsLoading.value = false
  }
}

// Управление закрытием диалога
const closeDialog = () => {
  emit('update:modelValue', false)
  eventForm.value?.resetValidation()
}

// 💾 Сборка LocalDateTime и отправка POST-запроса на бэкенд
const saveEvent = async () => {
  if (!isFormValid.value) return
  isSaving.value = true
  try {
    // Сначала объявляем переменные времени (чтобы они были доступны ниже)
    const startIso = `${newEvent.value.date}T${newEvent.value.startTime}:00`
    const endIso = newEvent.value.endTime ? `${newEvent.value.date}T${newEvent.value.endTime}:00` : null

    if (newEvent.value.eventType !== 'WEBINAR') {
      newEvent.value.webinarLink = ''
      newEvent.value.accessCode = ''
    }

    const materialIds = [...newEvent.value.attachedFileIds]
    if (newEvent.value.attachedVideoFile?.id) {
      materialIds.push(newEvent.value.attachedVideoFile.id)
    }

    // Отправляем тело запроса напрямую, удалив локальную переменную const payload
    await customAxios.post('/v1/schedule?currentUserId=1', {
      title: newEvent.value.title,
      description: newEvent.value.description,
      eventType: newEvent.value.eventType,
      startTime: startIso,
      endTime: endIso,
      webinarLink: newEvent.value.webinarLink,
      accessCode: newEvent.value.accessCode,
      targetTeamIds: newEvent.value.targetTeamIds,
      attachedMaterialIds: materialIds
    })

    emit('saved')
    closeDialog()
  } catch (e) {
    console.error('Не удалось сохранить событие расписания:', e)
  } finally {
    isSaving.value = false
  }
}


// Следим за открытием окна, чтобы инициализировать форму и подтянуть команды
watch(() => props.modelValue, (isOpen) => {
  if (isOpen) {
    newEvent.value = {
      ...defaultEvent,
      date: props.defaultDate || new Date().toISOString().split('T')[0]
    }
    fetchAvailableTeams()
  }
})
</script>